import { ApiCrud } from 'adready-api/api/api-crud';
import http from 'adready-api/api/http';

const filesAPI = new ApiCrud(http.AXIOS, {
  uploadOrganizationLogo: 'POST /files/organizations/:organizationId',
  uploadPublishersLog: 'POST /files/publisher/:publisherId',
});

export default filesAPI;
